import * as React from "react";

import { appendToClassName } from "lib/helpers";

import { ShareUrlButton } from "./ShareUrlButton";

interface State {
  hasClicked: boolean;
}

interface Props {
  valuationId: number;
  userId: number;
}

export class ShareWithAFriend extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = { hasClicked: false };
  }

  public render() {
    const { valuationId, userId } = this.props;

    const className = "invite-friend-raise-money";

    return (
      <>
        <div
          id="invite-friend-section"
          className={appendToClassName("valuation-section", className)}
        >
          <h1>Invite a Friend</h1>
          <label>
            Did you learn something about your music you didn’t know before?
          </label>
          <label>
            Invite a friend to create a profile and use the Know Your Worth app.
            They’ll get free royalty analytics for their catalog and access to
            all the features of Know Your Worth.
          </label>
          <div>
            <div className="horizontal-separator colored-section-separator separator" />
          </div>
          <div className="invite-friend-body">
            <p className="header-copy-link">
              Here is your personalized invite link
            </p>
            <ShareUrlButton valuationId={valuationId} userId={userId} />
          </div>
        </div>
      </>
    );
  }
}
